var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VTemplate',[_c('router-view'),(_vm.$route.name == 'Principal')?_c('Indicadores'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }